import { wrapperRequests } from "../services/api";
import { routesURL } from "../services/routesUrl";

export default function useRecoveryPassword() {
  async function resendEmail(email: string, countryCode: string) {
    if (!email || !countryCode) return;

    await wrapperRequests(routesURL.auth.passwordRecoverValidateEmail, "POST", {
      data: {
        email,
        countryCode,
      },
    });
  }

  async function updatePassword(
    email: string,
    recoveryCode: string,
    countryCode: string,
    password: string,
    passwordConfirmation: string,
  ) {
    await wrapperRequests(
      routesURL.auth.passwordRecoverUpdatePassword,
      "POST",
      {
        data: {
          email,
          recoveryCode,
          countryCode,
          password,
          passwordConfirmation,
        },
      },
    );
  }

  return { resendEmail, updatePassword };
}
